import { HttpClient, HttpParams } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { ApiResponse } from '@shared/models/api-response.model';
import { Cliente } from '@shared/models/cliente.model';
import { ICrudService } from '@shared/models/crud-service.model';
import { map, Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class ClienteService implements ICrudService<Cliente> {
  API: string = environment.API_URL;
  ruta: string = '/Cliente';
  _http: HttpClient = inject(HttpClient);

  save(item: Cliente): Observable<Cliente> {
    return this._http
      .post<ApiResponse<Cliente>>(`${this.API}${this.ruta}`, item)
      .pipe(map(({ value }) => value));
  }

  update(item: Cliente): Observable<Cliente> {
    return this._http
      .put<ApiResponse<Cliente>>(`${this.API}${this.ruta}`, item)
      .pipe(map(({ value }) => value));
  }

  findOne(item: Cliente): Observable<Cliente> {
    const params = new HttpParams().appendAll(item);
    return this._http
      .get<ApiResponse<Cliente>>(`${this.API}${this.ruta}/BuscarUno`, {
        params,
      })
      .pipe(map(({ value }) => value));
  }

  findFor(item: Partial<Cliente>): Observable<Cliente[]> {
    const params = new HttpParams().appendAll(item);
    return this._http
      .get<ApiResponse<Cliente[]>>(`${this.API}${this.ruta}/BuscarPor`, {
        params,
      })
      .pipe(map(({ value }) => value));
  }

  findAll(): Observable<Cliente[]> {
    return this._http
      .get<ApiResponse<Cliente[]>>(`${this.API}${this.ruta}`)
      .pipe(map(({ value }) => value));
  }
}
